import connectFactory from './connectFactory';
import createComponentFactory from './createComponentFactory';
import FelaComponentFactory from './FelaComponentFactory';
import FelaThemeFactory from './FelaThemeFactory';
import ProviderFactory from './ProviderFactory';
import ThemeProviderFactory from './ThemeProviderFactory';
import withThemeFactory from './withThemeFactory';
import createTheme from './createTheme';
import feFactory from './feFactory';
import { THEME_CHANNEL } from './themeChannel';

export { connectFactory, createComponentFactory, FelaComponentFactory, FelaThemeFactory, ProviderFactory, ThemeProviderFactory, withThemeFactory, createTheme, feFactory, THEME_CHANNEL };


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/es/index.js
// module id = 40
// module chunks = 0